import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Phone, Mail, MapPin, CheckCircle2,Clock, Users, Award, Heart, Eye } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
export default function OphthalmologyPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Ophthalmology");


  const subspecialties = [
    {
      title: "Cataract Services",
      description: "Phacoemulsification & advanced lens implants for clearer vision.",
      image: "/CataractServices.jpg",
    },
    // {
    //   title: "Cornea & Refractive Surgery",
    //   description: "LASIK, PRK, SMILE & corneal treatments for vision correction.",
    //   image: "/Cornea&RefractiveSurgery.jpg",
    // },
    {
      title: "Retina & Diabetic Eye Care",
      description: "Treatment for diabetic retinopathy, macular degeneration & retinal disorders.",
      image: "/Retina&DiabeticEyeCare.jpg",
    },
    {
      title: "Glaucoma Care",
      description: "Early diagnosis & long-term pressure management to prevent vision loss.",
      image: "/GlaucomaCare.jpg",
    },
    {
      title: "Pediatric Ophthalmology",
      description: "Squint correction, refractive errors & vision development in children.",
      image: "/PediatricOphthalmology.jpg",
    },
    {
      title: "Oculoplasty ",
      description: "Eyelid, tear duct & orbital surgeries for functional improvement",
      image: "/Oculoplasty&CosmeticEyeSurgery.jpg",
    },
  ];

  const treatments = [
    "Cataract Surgery (Phaco & Laser-Assisted)",
    // "LASIK & Refractive Error Correction",
    "Glaucoma Evaluation & Treatment",
    // "Diabetic Retinopathy Screening & Treatment",
    "Retina Laser, Injections & Vitrectomy",
    "Corneal Transplant & Keratoconus Treatment",
    "Squint Correction Surgery",
    "Dry Eye Treatment & Eye Allergy Care",
    "Comprehensive Eye Checkups",
  ];

  const whyChoose = [
    {
      icon: Users,
      title: "Expert Ophthalmologists",
      description: "Expert ophthalmologists skilled in advanced surgical techniques",
    },
    {
      icon: Award,
      title: "Latest Technology",
      description: "Latest phaco, femto-laser & LASIK technology for precise treatment",
    },
    {
      icon: Heart,
      title: "Comprehensive Care",
      description: "Comprehensive retina and diabetic eye care services",
    },
    {
      icon: Eye,
      title: "Pediatric-Friendly",
      description: "Pediatric-friendly eye screenings and treatments for children",
    },
    {
      icon: CheckCircle2,
      title: "Modern Diagnostics",
      description: "Modern eye diagnostics with OCT, Fundus & Visual Field Testing",
    },
  ];

  const articles = [
    {
      title: "When Should You Consider Cataract Surgery?",
      excerpt:
        "Learn about the signs that indicate it's time for cataract surgery and what to expect from the procedure.",
    },
    {
      title: "LASIK vs. SMILE — Which Vision Correction is Best for You?",
      excerpt: "Compare different refractive surgery options to find the best solution for your vision needs.",
    },
    {
      title: "How Diabetes Affects Your Vision",
      excerpt:
        "Understanding diabetic retinopathy and the importance of regular eye screenings for diabetic patients.",
    },
    {
      title: "Eye Problems in Children: Early Signs Parents Should Notice",
      excerpt:
        "Recognize the warning signs of childhood vision problems and learn when to seek professional help.",
    },
  ];

  const faqs = [
    {
      question: "Do you perform LASIK surgery?",
      answer:
        "Yes, we offer LASIK, SMILE, PRK, and other advanced refractive correction procedures. Our ophthalmologists use the latest laser technology to provide safe and effective vision correction.",
    },
    {
      question: "What are common symptoms of eye problems?",
      answer:
        "Blurry vision, headaches, redness, double vision, floaters, flashes, and light sensitivity. Sudden changes require urgent attention.",
    },
    {
      question: "Do you provide pediatric eye care?",
      answer:
        "Yes, we treat squint, refractive errors, lazy eye (amblyopia), and developmental vision issues in children.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Ophthalmology Department",
    "url": "https://mamshospitals.com/ophthalmology",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Ophthalmology.jpg",
    "description": "MAMS Hospitals provides advanced ophthalmology treatment in Hyderabad including cataract surgery, retina care, glaucoma treatment, pediatric ophthalmology, diabetic eye care, and LASIK evaluation.",
    "medicalSpecialty": "Ophthalmology",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Cataract Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Glaucoma Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Retina Laser & Vitrectomy"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Pediatric Eye Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Comprehensive Eye Checkups"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you perform cataract surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals performs advanced phaco and laser-assisted cataract surgeries with premium lens implants."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide diabetic eye care?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide retina screening, diabetic retinopathy treatment, laser procedures, and advanced retina care."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer pediatric ophthalmology services?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides pediatric eye care including squint correction, lazy eye treatment, and vision development screening."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Ophthalmology Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/ophthalmology",
    "description": "Best ophthalmology hospital in Hyderabad offering cataract surgery, retina care, glaucoma treatment, diabetic eye care, pediatric ophthalmology, and comprehensive eye checkups.",
    "keywords": [
      "Best Eye Hospital Hyderabad",
      "Best Ophthalmologist Hyderabad",
      "Cataract Surgery Hyderabad",
      "Retina Specialist Hyderabad",
      "Glaucoma Treatment Hyderabad",
      "Pediatric Ophthalmology Hyderabad",
      "Eye Hospital Bachupally"
    ]
  }
];

  return (
    <>
    <SEO
  title="Best Eye Hospital in Hyderabad | Ophthalmology Specialists | MAMS Hospitals"
  description="MAMS Hospitals offers advanced ophthalmology treatment in Hyderabad including cataract surgery, retina care, glaucoma treatment, diabetic eye care, pediatric ophthalmology, and comprehensive eye checkups."
  keywords="best eye hospital Hyderabad,
best ophthalmologist Hyderabad,
cataract surgery Hyderabad,
retina specialist Hyderabad,
glaucoma treatment Hyderabad,
diabetic eye care Hyderabad,
LASIK Hyderabad,
pediatric ophthalmology Hyderabad,
eye specialist Hyderabad,
comprehensive eye checkup Hyderabad,
retina surgery Hyderabad,
eye hospital Bachupally,
MAMS Hospitals Ophthalmology"
  schema={schema}
/>
    <div className="flex flex-col min-h-screen">

      {/* HERO */}
      <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

            <div>
              <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Best Ophthalmology Hospital in Hyderabad
              </div>

              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                Expert Eye Care for Brighter, Sharper Vision
              </h1>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                MAMS Hospitals provides advanced eye care services with cutting-edge diagnostic tools and expert surgeons.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>

            <div className="relative">
              <div className="absolute -top-4 -right-4 bg-teal-600 text-white p-6 rounded-2xl shadow-xl z-10">
                <div className="text-3xl font-bold">20/20</div>
                <div className="text-sm">Vision Care</div>
              </div>

              <img
                src="/Ophthalmology.jpg"
                alt="Eye Care at MAMS Hospital"
                className="rounded-2xl shadow-2xl w-full"
              canonicalUrl="https://mamshospitals.com/departments/ophthalmology"
      />
            </div>

          </div>
        </div>
      </section>

      {/* SUB-SPECIALTIES */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Sub-Specialties in Ophthalmology</h2>
            <p className="text-lg text-gray-600">Complete eye care across all major specialties</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((item, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-teal-500">
                <CardContent className="p-0">
                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform"
                    />
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section>

      {/* TREATMENTS */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Treatments & Procedures</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Advanced procedures performed with precision and safety
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {treatments.map((t, i) => (
              <div key={i} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                <CheckCircle2 className="h-6 w-6 text-teal-600 mt-1" />
                <span className="text-gray-700">{t}</span>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Why Choose MAMS Hospitals</h2>
            <p className="text-gray-600">Modern eye care with experienced ophthalmologists</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, i) => (
              <Card key={i} className="border-gray-200 hover:shadow-lg transition">
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                    <item.icon className="h-7 w-7 text-teal-600" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section>

      {/* SPECIALIST */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}

      {/* ARTICLES */}
      {/* <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl text-center">

          <h2 className="text-3xl font-bold mb-4">Recent Articles</h2>
          <p className="text-gray-600 mb-12">Stay informed about eye health</p>

          <div className="grid md:grid-cols-2 gap-6">
            {articles.map((article, i) => (
              <Card key={i} className="hover:shadow-xl border-gray-200 transition cursor-pointer">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-3">{article.title}</h3>
                  <p className="text-gray-600">{article.excerpt}</p>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section> */}

      {/* FAQ */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-0 max-w-4xl">

          <h2 className="text-3xl font-bold text-center mb-4">Frequently Asked Questions</h2>
          <p className="text-gray-600 text-center mb-12">Quick answers about eye care</p>

          <Accordion type="single" collapsible>
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`}>
                <AccordionTrigger>{faq.question}</AccordionTrigger>
                <AccordionContent>{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
    </>
  );
}
